export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const AUTO_LOGIN = 'AUTO_LOGIN';
export const SOCIAL = 'SOCIAL';
export const SOCIAL_SUCCESS = 'SOCIAL_SUCCESS';
export const SOCIAL_FAILURE = 'SOCIAL_FAILURE';
export const GET_AUTH_LINK = 'GET_AUTH_LINK';
export const START_SYNC = 'START_SYNC';
export const LOGIN_RESET = 'LOGIN_RESET';
export const LOGOUT = 'LOGOUT';
